<template>
  <div class="year-selector">
    <div class="content-wrap">
      <h2 class="title">
        <span>📘 اختبر نفسك قبل الامتحان</span>
      </h2>

      <div class="years-grid">
        <button
          v-for="year in options"
          :key="year"
          :disabled="isLocked(year)"
          @click="select(year)"
          :class="['year-button', { locked: isLocked(year) }]"
          type="button"
        >
          <span class="year-content">
            <span class="year-text">{{ bankLabel(year) }}</span>
            <span v-if="isLocked(year)" class="lock-icon">🔒</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'YearSelector',

  props: {
    options: {
      type: Array,
      required: true
    },
    type: { // B / w / M / D / T
      type: String,
      required: true
    },
    activated: {
      type: Boolean,
      default: false
    },
    lockedYears: {
      type: Array,
      default: () => []
    }
  },

  emits: ['select'],

  methods: {
    select(year) {
      if (!this.isLocked(year)) {
        this.$emit('select', year);
      }
    },

    isLocked(year) {
      const y = Number(year);
      return this.lockedYears.includes(y) && !this.activated;
    },

    bankLabel(year) {
      const y = Number(year);

      // -----------------------------
      // 🔥 بنوك B — صياغات مشوّقة وآمنة
      // -----------------------------
      const labelsB = {
        1: ' الأزمنة –  1 (مجمعة بعناية بشكل متدرج من مراجع و دورات  سابقة)',
        2: ' الأزمنة –  2 (  تجميع من مراجع واسئلة دورات سابقة)',
        3: ' الأزمنة –  3 (أسئلة مركزة وفيها نكشات هامة من سنوات سابقة)',
        4: ' الأزمنة –  4 (تجميع احترافي)',
        5: ' الأزمنة –  5 (مراجعة مركّزة)',
        6: 'حروف الجر – مجمّعة من مراجع ودورات سابقة',
        7: 'الأفعال المركبة – تمارين منتقاة من مراجع ودورات سابقة',
        8: 'الأسماء الموصولة – تجميع من نماذج سابقة',
        9: 'محددات الكمية –  تجميع من دورات سابقة',
        10: 'الأفعال المساعدة الناقصة – مراجعة من سنوات سابقة',
        11: 'أدوات الربط – تجميع احترافي من نماذج سابقة',
        12: 'اللواحق –  تجميع من دورات سابقة',
        13: 'استخدام اللغة – تدريب شامل من مراجع ودورات سابقة',
        14: 'حدّد الجزء غير الصحيح – من مراجع متداولة بين الطلاب معتمدة',
        15: 'ميّز الجملة غير الصحيحة – تدريب من مراجع متداولة   ',
        16: 'اختر الجملة الصحيحة – من مراجع متداولة    ',
        17: 'بنك المفردات – تجميع واسع من مراجع متداولة',
        18: 'بنك المفردات – تجميع من مراجع ونوط متداولة   ',
        19: 'بنك المفردات – تدريب شامل',
        20: 'بنك المفردات – مراجعة مركّزة',
        21: 'بنك المفردات – أسئلة مركزة',
        22: 'مرادفات – تمارين منتقاة من دورات سابقة',
        23: 'أسئلة شائعة من دورات سابقة – تدريب على الأنماط المتكررة',

        24: 'محاكي الامتحان 1 – نموذج دورة سابقة مُعاد تنظيمه',
        25: 'محاكي الامتحان 2 – تجربة امتحان من نماذج سابقة',
        26: 'محاكي الامتحان 3 – محاكاة دقيقة من دورة سابقة',
        27: 'محاكي الامتحان 3 – نسخة تدريبية من نموذج سابق',
        28: 'محاكي الامتحان 4 – نموذج تدريبي من سنوات سابقة',
        29: 'محاكي الامتحان 5 – محاكاة امتحانية من نماذج سابقة',
        30: 'محاكي الامتحان 6 – نموذج سابق مُعاد ترتيبه',
        31: 'محاكي الامتحان 7 – تجربة امتحان من دورات سابقة',
        32: 'محاكي الامتحان 8 – محاكاة تدريبية من نماذج سابقة',
        33: 'محاكي الامتحان 9 – نموذج امتحاني من سنوات سابقة'
      };

      // -----------------------------
      // 🔥 بنوك D — نفس الأسلوب
      // -----------------------------
      const labelsD = {
        1: '28-11-2023',
        2: '21-5-2024',
        3: '16-7-2024',
        4: '12-9-2017',
        5: 'بنك  شامل – من دورات سابقة',
        6: '5-3-2024',
        
       7: 'جامعة ادلب 14-10-2025',
       8: 'دكتوراه 2026'


      };

      // -----------------------------
      // 🔥 بنوك T — صياغة مشوّقة
      // -----------------------------
      const labelsT = {
        1: 'إتقان الأزمنة – مستوى 1',
        2: 'إتقان الأزمنة – مستوى 2',
        3: 'إتقان الأزمنة – مستوى 3',
        4: 'إتقان الأزمنة – مستوى 4',
        5: 'إتقان الأزمنة – مستوى 5',
        6: 'حروف الجر – تجميع احترافي ',
        7: 'الأفعال المركبة – تجميع احترافي ',
        8: 'الأسماء الموصولة – تجميع احترافي ',
        9: 'محددات الكمية – تجميع احترافي من مراجع ودورات سابقة',
        10: 'الأفعال المساعدة الناقصة – تجميع احترافي من مراجع ودورات ',
        11: 'أدوات الربط – نماذج سابقة',
        12: 'اللواحق – تدريب ',
        13: 'استخدام اللغة – تدريب شامل',
        14: 'حدّد الجزء غير الصحيح – تجميع من مراجع ودورات سابقة',
        15: 'ميّز الجملة غير الصحيحة   ',
        16: 'اختر الجملة الصحيحة – نماذج سابقة',
        17: 'مفردات –  تجميع من مراجع ودورات سابقة',
        18: 'مفردات –  تجميع احترافي',
        19: 'مفردات – تجميع احترافي ',
        20: 'مفردات – تجميع احترافي ',
        21: 'مفردات – مراجعة مركّزة',
        22: 'مرادفات – تجميع احترافي ',
        23: 'بنك شامل نماذج سابقة – من دورات سابقة'
      };

      // -----------------------------
      // 🔥 بنوك W — صياغة محسّنة
      // -----------------------------
      const labelsW = {
        1: 'إتقان الأزمنة –  1',
        2: 'إتقان الأزمنة –  2',
        3: 'إتقان الأزمنة –  3',
        4: 'إتقان الأزمنة –  4',
        5: 'إتقان الأزمنة –  5',
        6: 'حروف الجر – مجمع من نماذج سابقة',
        7: 'الأفعال المركبة – تجميع احترافي من نماذج سابقة',
        8: 'الأسماء الموصولة – مجمع من نماذج سابقة',
        9: 'محددات الكمية – أسئلة سابقة',
        10: 'الأفعال المساعدة الناقصة – مجمع من نماذج سابقة',
        11: 'أدوات الربط – نماذج سابقة',
        12: 'اللواحق –  تجميع احترافي',
        13: 'استخدام اللغة – تجميع احترافي ',
        14: 'حدّد الجزء غير الصحيح – تجميع احترافي ',
        15: 'ميّز الجملة غير الصحيحة – تجميع احترافي ',
        16: 'اختر الجملة الصحيحة – تجميع احترافي '
      };

      // -----------------------------
      // 🔥 بنوك M — صياغة محسّنة
      // -----------------------------
      const labelsM = {

          // 🟦 2025
          28: 'دمشق 24-12-2025 النموذج ب',
          27: 'دمشق 24-12-2025 النموذج أ',
          26: 'دمشق31-8-2025',

          // 🟦 2024
          25: 'دمشق 15-1-2024',
          24:  'اللاذقية 15-1-2024',

          // 🟦 2023
          23: 'دمشق 8-10-2023 نموذج ب',
          22: 'دمشق 8-10-2023 نموذج أ',
          21: 'طرطوس 5-3-2023',
          20: 'طرطوس 6-3-2023',
          19: 'طرطوس 4-6-2023',
          18: 'طرطوس 8-10-2023',
          17: 'اللاذقية 8-10-2023',

          // 🟦 2022
          16: 'طرطوس 6-3-2022',
          15: 'طرطوس 5-6-2022',
          14: 'حماة 2022',

          // 🟦 2021
          13:  'دمشق 21-6-2021',
          12:  'دمشق 13-3-2021',
          11: 'حلب 12-6-2021',
          10:  'حلب 13-3-2021',

          // 🟦 2020
          9:  'دمشق 22-9-2020',
          8:  'دمشق 2020 ',
          7:  'دمشق 11-7-2020',
         6:  'دمشق 29-11-2020',
          5:  'دمشق6-6-2020',
          4: 'حلب 17-5-2020',

          // 🟦 2018 – 2017
          3: 'دمشق 14-7-2018',
          2: 'دمشق 2018',
          1: 'دمشق 2017',


           // 🟦 
          29: ' جامعة الفرات - تشرين الاول 2025',
          30: 'جامعة اللاذقية - ايلول -2025 ',
          31: 'جامعة ادلب-14-10-2025 ',

          32: ' جامعة حمص -2025',
          33: 'جامعة دمشق - 2026',
        };

      const maps = { B: labelsB, D: labelsD, w: labelsW, M: labelsM, T: labelsT };
      const selectedMap = maps[this.type] || {};

      return selectedMap[y] || `البنك رقم ${y}`;
    }
  }
};
</script>




<style scoped>

/* Tajawal Arabic font for premium feel */
@import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;600;800;900&display=swap');

/* Root theme tokens */
:root {
  --gold-25: rgba(212, 175, 55, 0.25);
  --gold-35: rgba(212, 175, 55, 0.35);
  --gold: #e8c55a;
  --gold-deep: #c9a63a;

  --bg-0: #000000;
  --bg-1: #0a0a0a;

  --text: #f5f5f7;
  --text-dim: #b7b7bf;

  /* Open buttons highlight */
  --open-cyan-1: #22d3ee; /* cyan */
  --open-cyan-2: #2dd4bf; /* teal */
  --open-glow: rgba(34, 211, 238, 0.28);

  /* Locked tone */
  --locked: #a1a1aa;

  --rad-2xl: 26px;
  --rad-xl: 22px;
  --rad-lg: 16px;

  --t: 260ms cubic-bezier(.25,.8,.25,1);
  --pulse-dur: 2.2s;
}

/* Global reset for horizontal safety and smoothness */
*,
*::before,
*::after {
  box-sizing: border-box;
}
html,
body {
  padding: 0;
  margin: 0;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden; /* no horizontal scroll */
  background: var(--bg-0);
  font-family: 'Tajawal', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  -webkit-tap-highlight-color: transparent;
  direction: rtl;
}

/* Host section */
.year-selector {
  min-height: 100vh;
  width: 100%;
  display: grid;
  place-items: center;
  overflow-x: hidden; /* safety */
  padding: max(12px, env(safe-area-inset-top)) max(12px, env(safe-area-inset-inline-start)) max(16px, env(safe-area-inset-bottom)) max(12px, env(safe-area-inset-inline-end));
  background:
    radial-gradient(1200px 600px at 50% -10%, rgba(255,255,255,0.05), transparent 60%),
    linear-gradient(180deg, var(--bg-0), var(--bg-1) 60%, var(--bg-0));
  color: var(--text);
}

/* Content wrapper stays comfortably within mobile width */
.content-wrap {
  width: min(94vw, 880px);
  margin: 0 auto;
  padding: clamp(12px, 2vw, 20px);
  display: grid;
  gap: clamp(12px, 2.8vw, 18px);
}

/* Title styling */
.title {
  margin: 0;
  text-align: center;
  font-weight: 900;
  letter-spacing: 0.2px;
  font-size: clamp(1.25rem, 4.2vw, 1.9rem);
  line-height: 1.25;
  color: #fff;
  text-shadow:
    0 2px 6px rgba(0,0,0,0.55),
    0 0 1px rgba(255,255,255,0.25);
}

/* Grid: mobile-first, responsive, no overflow */
.years-grid {
  display: grid;
  grid-template-columns: 1fr; /* single column on small screens */
  gap: clamp(10px, 3vw, 14px);
  width: 100%;
  padding: clamp(12px, 3vw, 18px);
  border-radius: var(--rad-2xl);

  background: linear-gradient(180deg, rgba(18,18,20,0.7), rgba(16,16,18,0.52));
  border: 1px solid var(--gold-35);
  outline: 1px solid rgba(255,255,255,0.04);
  backdrop-filter: blur(16px) saturate(160%);
  -webkit-backdrop-filter: blur(16px) saturate(160%);
  box-shadow:
    0 10px 28px rgba(0,0,0,0.65),
    0 0 22px var(--gold-25);
}

/* On wider screens, allow multiple columns without causing horizontal scroll */
@media (min-width: 520px) {
  .years-grid {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  }
}
@media (min-width: 768px) {
  .years-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

/* Button: wrapped text, centered, luxurious capsule, soft motion */
.year-button {
  position: relative;
  width: 100%;
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 9999px; /* premium capsule */
  padding: clamp(12px, 3.2vw, 16px) clamp(14px, 3.6vw, 22px);
  background:
    linear-gradient(180deg, rgba(38,38,42,0.66), rgba(16,16,18,0.8)),
    radial-gradient(140% 180% at 20% 0%, rgba(232,197,90,0.08), transparent 60%);
  color: var(--text);
  font-weight: 800;
  font-size: clamp(1rem, 2.8vw, 1.05rem);
  line-height: 1.5;
  text-align: center;
  cursor: pointer;
  user-select: none;
  touch-action: manipulation;
  transition:
    transform var(--t),
    box-shadow var(--t),
    color var(--t),
    background var(--t),
    border-color var(--t),
    filter var(--t);

  /* Center content and allow multiline */
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 56px;
  white-space: normal;   /* allow wrapping */
  overflow: visible;
  word-break: break-word;

  box-shadow:
    0 6px 14px rgba(0,0,0,0.5),
    inset 0 0 0 0 rgba(232,197,90,0);
}

/* Soft diagonal sheen */
.year-button::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(115deg, transparent 35%, rgba(255,255,255,0.12) 50%, transparent 65%);
  transform: translateX(-140%);
  transition: transform 900ms ease;
  pointer-events: none;
}
.year-button:hover::after {
  transform: translateX(140%);
}

/* Hover/active/keyboard */
.year-button:hover {
  transform: translateY(-2px);
  border-color: rgba(232,197,90,0.35);
  box-shadow:
    0 12px 24px rgba(0,0,0,0.55),
    inset 0 0 12px rgba(232,197,90,0.14);
  filter: brightness(1.02);
}
.year-button:active {
  transform: translateY(0);
  box-shadow:
    0 8px 16px rgba(0,0,0,0.45),
    inset 0 0 8px rgba(232,197,90,0.12);
  filter: brightness(0.98);
}
.year-button:focus-visible {
  outline: none;
  box-shadow:
    0 0 0 3px rgba(232,197,90,0.28),
    0 8px 18px rgba(0,0,0,0.5);
}

/* Content layout inside button */
.year-content {
  display: grid;
  grid-auto-flow: row;
  align-items: center;
  justify-items: center;
  gap: 0.35rem;
  width: 100%;
  max-width: 100%;
}
.year-text {
  display: block;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

/* Locked button: elegant, subtle, with refined lock accent and soft shimmer */
.year-button.locked {
  background:
    linear-gradient(180deg, #2b2b2f, #1c1c20);
  color: var(--locked);
  cursor: not-allowed;
  border-color: rgba(255,255,255,0.08);
  box-shadow: none;
  position: relative;
}
.year-button.locked::before {
  /* gentle inner vignette */
  content: "";
  position: absolute;
  inset: 2px;
  border-radius: 9999px;
  background: radial-gradient(120% 150% at 50% 0%, rgba(255,255,255,0.04), transparent 60%);
  pointer-events: none;
}
.year-button.locked .lock-icon {
  margin-inline-start: 0.35rem;
  font-size: 1.05rem;
  filter: drop-shadow(0 0 4px rgba(0,0,0,0.4));
}

/* OPEN button: distinct cyan-teal gradient + soft pulsing aura */
.year-button:not(.locked) {
  background:
    linear-gradient(180deg, rgba(14,14,18,0.88), rgba(10,10,12,0.95)),
    linear-gradient(135deg, rgba(34,211,238,0.18), rgba(45,212,191,0.14));
  border-color: rgba(34,211,238,0.5);
  color: #eaffff;
  box-shadow:
    0 0 0 0 var(--open-glow),
    0 10px 22px rgba(0,0,0,0.5);
  animation: pulseGlow var(--pulse-dur) ease-in-out infinite;
}
.year-button:not(.locked):hover {
  border-color: rgba(34,211,238,0.75);
  background:
    linear-gradient(180deg, rgba(18,18,22,0.9), rgba(12,12,14,0.96)),
    linear-gradient(135deg, rgba(34,211,238,0.25), rgba(45,212,191,0.22));
  box-shadow:
    0 0 0 10px rgba(34,211,238,0.06),
    0 14px 26px rgba(0,0,0,0.55),
    inset 0 0 12px rgba(34,211,238,0.18);
}
.year-button:not(.locked):active {
  animation: none;
  box-shadow:
    0 0 0 0 var(--open-glow),
    0 10px 18px rgba(0,0,0,0.5),
    inset 0 0 10px rgba(34,211,238,0.2);
}

/* Gentle pulsing aura for open buttons */
@keyframes pulseGlow {
  0% {
    box-shadow:
      0 0 0 0 rgba(34,211,238,0.22),
      0 10px 22px rgba(0,0,0,0.5);
  }
  50% {
    box-shadow:
      0 0 0 12px rgba(34,211,238,0.06),
      0 12px 26px rgba(0,0,0,0.55);
  }
  100% {
    box-shadow:
      0 0 0 0 rgba(34,211,238,0.22),
      0 10px 22px rgba(0,0,0,0.5);
  }
}

/* Mobile optimizations: keep everything within the viewport */
@media (max-width: 420px) {
  .years-grid {
    grid-template-columns: 1fr;
    padding: 12px;
    gap: 10px;
  }
  .year-button {
    font-size: 1rem;
    min-height: 56px;
  }
}

/* Optional: slightly larger gutters on big screens, still safe for overflow-x */
@media (min-width: 1024px) {
  .content-wrap {
    width: min(92vw, 880px);
  }
}

</style>